import { useContext } from 'react';

import { SocketContext } from '@/contexts/rtm';
import { SocketEvent } from '@/shared/types/rtm';

import { bind, useRtmBindings } from './rtmBindings';
import { onViewUpdated } from '../useViews';

export const viewBindings = [
  bind(SocketEvent.views_created, (data, { rtm }) =>
    rtm.create('views', data.desk_id, data.view_id)
  ),
  // Applied from the payload rather than refetched: after an update the user may no longer have
  // access to the view, and fetching it would fail.
  bind(SocketEvent.views_updated, (data, { queryClient }) => onViewUpdated(queryClient, data)),
  bind(SocketEvent.views_removed, (data, { rtm }) =>
    rtm.remove('views', data.desk_id, data.view_id)
  ),
];

export const useRtmViews = () => {
  const { socket } = useContext(SocketContext);

  useRtmBindings(socket, viewBindings);
};
